<template>
    <div class="AppointmentsLayout" v-if="UserPrivateProfile.UserId">
        <div>
            <nav class="navbar navbar-light navbar-expand-md navigation-clean">
                <div class="container-fluid">
                    <a id="navbar-brand" class="navbar-brand pointer"><router-link to="/"><img v-bind:src="sitelogo" /></router-link></a><button data-toggle="collapse" class="navbar-toggler" data-target="#navcol-1"><span class="sr-only">Toggle navigation</span><span class="navbar-toggler-icon"></span></button>
                    <div class="collapse navbar-collapse"
                         id="navcol-1">
                        <b-nav pills class="ml-auto" style="margin-right:50px;">
                            <b-nav-item class="hidden" role="presentation"></b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('AppointmentBlocks')" v-bind:class="{ active: PaneShown == 'AppointmentBlocks' }"><i class="fa fa-calendar" /> Appointment Blocks</b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('Reports')" v-bind:class="{ active: PaneShown == 'Reports' }"><i class="fa fa-bar-chart" /> Reports</b-nav-item>
                            <!--<b-nav-item v-on:click="ChangePaneShown('ReportsPane')" v-bind:class="{ active: PaneShown == 'ReportsPane' }"><font-awesome-icon :icon="['fa', 'chart-bar']" /> Reports</b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('DashboardPane')" v-bind:class="{ active: PaneShown == 'DashboardPane' }"><font-awesome-icon :icon="['fa', 'chart-bar']" /> Dashboard</b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('FileUploadPane')" v-bind:class="{ active: PaneShown == 'FileUploadPane' }"><font-awesome-icon :icon="['fa', 'file-upload']" /> File Uploads</b-nav-item>-->
                            <b-nav-item><Logout /></b-nav-item>
                        </b-nav>
                    </div>
                </div>
            </nav>
        </div>

        <div class="tab-content col-12 padding-adjust-for-overlay-scroll">
            <div v-if="PaneShown == 'AppointmentBlocks'">
                <div class="paper">
                    <ProviderAppointmentBlocks />
                </div>
            </div>
            <div v-if="PaneShown == 'Reports'">
                <div class="paper">
                    <ReportsPane />
                </div>
            </div>
        </div>
        <!--Logged in User-->
        <p class="upper-right" v-if="UserPrivateProfile.FirstName">Logged in as: {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</p>
    </div>
</template>

<script>
    //import components
    //import { UserAPI } from '../../../services/api/Core/UserAPI.js';
    import ProviderAppointmentBlocks from '../Appointments/ProviderAppointmentBlocks.vue';
    import ReportsPane from '../Appointments/ReportsPane.vue';

    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
    library.add(faFileInvoiceDollar);
    import { faFileUpload } from '@fortawesome/free-solid-svg-icons';
    library.add(faFileUpload);
    import { faChartBar } from '@fortawesome/free-solid-svg-icons';
    library.add(faChartBar);
    
    
    export default {
        name: "AppointmentsLayout",
        created() {
            //const userAPI = new UserAPI(this.$baseURL);
            //this.userAPI = userAPI;
            //this.$store.commit("User.PrivateProfile.Clear");
        },
        data: function () {
            return {
                sitelogo: "/images/OliveCrestLogo_OLIVER.png",
                PaneShown: "AppointmentBlocks"
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            GetEmployeePrivateProfile() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/User/GetEmployeePrivateProfileLite", {} , this.GetEmployeePrivateProfileSuccess, () => { }, true);
            },
            GetEmployeePrivateProfileSuccess(response) {
                this.$store.commit("User.PrivateProfile.Replace", response.data.data);
            }

        },
        components: {
            ProviderAppointmentBlocks,
            ReportsPane
        },
        mounted() {
            this.GetEmployeePrivateProfile();
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            }
        }
    }
</script>

<style scoped>
    .upper-right {
        position:absolute;
        top:0;
        right:40px;
    }

    .AppointmentsLayout {
        background-color: #605271;
    }
</style>